"use client";
import FormInput from "@components/form-items/FormInput";
import Button from "antd/es/button";
import Form from "antd/es/form";
import Radio from "antd/es/radio";
import downloadjs from "downloadjs";
import html2canvas from "html2canvas";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function StripeGeneratorComponent() {
  const [form] = Form.useForm();
  const [data, setData] = useState({
    background: "/wallpapers/city.jpeg",
    carrier: "Viettel",
    amount: "99.00",
    email: "patrick@stripe.com",
  } as any);

  let backgroundImages = [
    "/wallpapers/city.jpeg",
    "/wallpapers/blue-burst.jpeg",
    "/wallpapers/green-valley.jpg",
    "/wallpapers/abstract.jpeg",
  ];

  useEffect(() => {
    form.setFieldsValue(data);
  }, []);

  async function onFormChange() {
    const val = form.getFieldsValue();
    setData(val);
  }
  const onSubmit = async () => {
    const imgElement = document.querySelector<HTMLElement>("#export-img");
    if (!imgElement) return;
    const canvas = await html2canvas(imgElement, {
      scale: 2,
      width: 340,
      height: 600,
    });
    const dataURL = canvas.toDataURL("image/jpeg");

    downloadjs(dataURL, "download.png", "image/jpeg");
  };

  return (
    <main className="polka mt-5 flex h-full flex-col items-center justify-center gap-10 pt-4 md:flex-row md:gap-10 md:p-4">
      <div className="text-card-foreground w-[340px] rounded-xl border bg-surface shadow md:h-[600px]">
        <div className="flex flex-col space-y-1.5 p-6">
          <h3 className="font-semibold leading-none">
            Stripe Notification Generator
          </h3>
          <p className="text-muted-foreground text-sm">
            Generate fake Stripe payment notifications to fool your friends or
            manifest your goals.
          </p>
        </div>
        <div className="p-6 pt-0">
          <Form
            form={form}
            onChange={onFormChange}
            layout="vertical"
            initialValues={data}
          >
            <div className="grid w-full items-center gap-4">
              <div className="flex flex-col space-y-1.5">
                <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                  Wallpaper
                </label>

                <Form.Item
                  name="background"
                  className="hide-radio mt-3 space-x-2"
                >
                  <Radio.Group className="flex justify-between gap-4">
                    {backgroundImages.map((image, i) => {
                      return (
                        <Radio key={i} value={image}>
                          <Image
                            className="h-16 w-16 rounded-md"
                            src={image}
                            alt=""
                            width={16}
                            height={16}
                            key={i}
                          />
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </Form.Item>
              </div>
              <div className="flex flex-col">
                <FormInput name="carrier" label="Carrier"></FormInput>
              </div>
              <div className="flex flex-col">
                <FormInput
                  name="amount"
                  label="Amount"
                  placeholder="Amount of payment"
                ></FormInput>
              </div>
              <div className="flex flex-col">
                <FormInput
                  name="email"
                  label="Email"
                  placeholder="Email of customer"
                ></FormInput>
              </div>
            </div>
          </Form>
        </div>
        <div className="flex items-center p-6 pt-0">
          <Button type="primary" onClick={onSubmit} className="w-full">
            Download Image
          </Button>
        </div>
      </div>
      <div className="flex h-full w-full flex-1 justify-center md:items-center">
        <div className="h-fit w-fit rounded-lg" id="export-img">
          <div className="relative h-[600px] w-[340px]">
            <img className="h-full w-full" src={data.background} alt="" />
            <div className="absolute top-0 z-50 flex w-full items-center justify-between px-3.5 pt-1">
              <div className="text-xs font-medium text-white">
                {data.carrier}
              </div>
              <div className="flex items-center space-x-1.5">
                <img src="/wallpapers/wifi.svg" className="h-4 w-4" />
                <img src="/wallpapers/battery.svg" className="h-4 w-4" />
              </div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="flex min-h-[4rem] w-80 items-center rounded-xl bg-gray-100/90 px-3 py-2">
                <img
                  className="h-10 w-10 rounded-lg"
                  src="/wallpapers/stripe.png"
                  alt=""
                />
                <div className="ml-3 flex-1">
                  <div className="flex justify-between">
                    <div className="text-sm font-semibold">Stripe</div>
                    <div className="text-xs font-medium text-gray-500">
                      2m ago
                    </div>
                  </div>
                  <div className="text-sm">
                    You received a payment of ${data.amount} from&nbsp;
                    {data.email}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="view-export"></div>
    </main>
  );
}
